import React from 'react';
import { Grid2, Typography, Box } from '@mui/material';
import { AddonCard } from 'components'; // Assuming AddonCard is properly typed and exported
import { RentalRate } from 'types/BookingDetails';
interface AncillaryCardProps {
  ancillaryData: RentalRate[] | null;
  onSelect?: (
    ChargeCode: string,
    chargeCodeType: number,
    ancillary: RentalRate
  ) => void;
}

export const AncillaryCard: React.FC<AncillaryCardProps> = ({
  ancillaryData,
  onSelect,
}) => {
  const ANCILARIES = ['COT', 'VRF', 'ADR'];
  return (
    <Box className="box-container-layout">
      <Typography
        color="primary"
        sx={{ textAlign: 'start', marginBottom: '40px', fontWeight: 'normal' }}
      >
        Choose your{' '}
        <span style={{ textDecoration: 'underline', fontWeight: '600' }}>
          Add-Ons
        </span>
      </Typography>
      <Grid2 container spacing={2}>
        {ancillaryData &&
          ancillaryData.map(
            (ancillary: RentalRate, index: number) =>
              ANCILARIES.includes(ancillary.Code) && (
                <Grid2 size={{ sm: 6 }} key={index}>
                  <AddonCard
                    id={ancillary.Code}
                    title={ancillary.Name}
                    description={ancillary.Description}
                    price={ancillary.TotalAmt}
                    numberOfDays={ancillary.Duration}
                    isChecked={
                      ancillary.IsCompulsory
                        ? ancillary.IsCompulsory
                        : ancillary.IsSelected
                    }
                    onCheck={() =>
                      onSelect && onSelect(ancillary.Code, 1, ancillary)
                    }
                    isCompulsoryOnRental={ancillary.IsCompulsory}
                  />
                </Grid2>
              )
          )}
      </Grid2>
    </Box>
  );
};
